export default __webpack_public_path__ + "static/assets/AllianceNo1Light.6a598a08.woff";